
<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.roles')"
      show_usermenu
    ></my-header>
    <reference-grid
      :gridData="getRolesTableArray"
      :columns="columnDefs"
      gridType="role"
      @deleteClicked="deleteClick"
    ></reference-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import ReferenceGrid from "../../components/reference/ReferenceGrid";
import { mapGetters } from "vuex";
import i18n from "@/locales";
export default {
  data() {
    return {
      columnDefs: [],
    };
  },
  methods: {
    deleteClick({currentId, title}) {
      this.$confirm(this.$t('roles.thisActionDeleteThisRole') + ' ' + title + ". " + this.$t('roles.continue') + "?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: this.$t('roles.cancellation'),
        type: "warning",
      })
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("deleteRole", currentId);
        })
        .then(() => {
          return this.$store.dispatch("getRoleTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
  created() {
    this.$store.commit("setLoading", true);
    this.columnDefs = [
      {
        headerName: i18n.t("tableHeaders.role.id"),
        field: "id",
        comparator: (value1, value2) => parseInt(value1) - parseInt(value2),
        cellClass: "center-column",
        width: 80
      },
      { headerName: i18n.t("tableHeaders.role.name"), field: "name" },
      {
        headerName: i18n.t("tableHeaders.role.type"),
        field: "type",
        comparator: (value1, value2) => parseInt(value1) - parseInt(value2),
        cellClass: "center-column",
        width: 80
      },
    ];
    this.$store.dispatch("getRoleTable").catch(() => {
      this.$store.commit("setLoading", false);
    });
  },
  computed: {
    ...mapGetters(["getRolesTableArray"]),
  },
  components: {
    myHeader: Header,
    ReferenceGrid,
  },
};
</script>